module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/slide_04-369f4c15b9e376c970c5d8a473fcd8d2.png";